import { EColor } from '../../types';

// Заменить на цвет из кита, когда цвет будет поддерживаться в ките.
const ACCENT_PRIMARY_POSITIVE = '#34ac0a';

export const getTextColor = (labelColor: EColor) => {
  switch (labelColor) {
    case 'blueGoodPrice':
    case 'blueOnlyCian':
    case 'blue':
      return 'accent-main-primary';
    case 'greenForCheckedOwner':
    case 'greenForOwner':
    case 'green':
    case 'greenForSuperAgent':
      return ACCENT_PRIMARY_POSITIVE;
    case 'orange':
      return 'accent-warning-primary';
    case 'white':
      return 'theme-dark';
    case 'purpleDiscountMortgage':
      return 'decorative-purple';
    default:
      return 'theme-dark';
  }
};
